import { newAPI } from '../../../services';
import qs from 'qs';

export const fetchClientArea = async (userId, establishmentId) => {
  const url = !!establishmentId ? `${userId}/establishment/${establishmentId}/client-area` : `${userId}/client-area`;

  const response = await newAPI.get(url);
  return response.data;
}

export const fetchClientAreaPlans = async (userId, establishmentId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/client-area/plans`);
  return response.data;
}

export const activateFirstCharge = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/client-area/activate-first-charge`, qs.stringify(params));
  return response.data;
}

export const reprocessCreditCardCharge = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/client-area/reprocess-credit-card-charge`, qs.stringify(params));
  return response.data;
}

export const sendChargeEmail = async (userId, params) => {
  const response = await newAPI.post(`${userId}/client-area/charges/send-email`, qs.stringify(params));
  return response.data;
}

export const generateToken = async (userId, token, body) => {
  newAPI.defaults.headers.common['Authorization'] = token;

  const response = await newAPI.post(`${userId}/superlogica/token`, qs.stringify(body));
  return response.data;
}